import { produce } from "immer";
import { ActionTypes } from "./actions";
import { IRootObject as IState, IAction } from "./types";

export const initialState = Object.freeze<IState>({
    countries: [],
    currencies: [],
    countryCode: "IN",
    country: "India",
    currency: "INR",
    flagUrl: "",
    currencyDisplayValue: "₹",
    openDialog: false,
    isLoading: false,
    hasUpdatedI18n: false,
    onGDPRNetwork: false,
    isXHRAllowed: true,
});

export default (state: IState = initialState, action: IAction): IState =>
    produce(state, draft => {
        const { type, payload } = action;
        switch (type) {
            case ActionTypes.INTERNATIONALIZATION_SUCCESS: {
                const { default: _default, ...rest } = payload;
                draft = {
                    ...state,
                    ...rest,
                    ..._default,
                    isLoading: false,
                    hasUpdatedI18n: true,
                };

                return draft;
            }
            case ActionTypes.INTERNATIONALIZATION_PROCESSING: {
                draft.isLoading = true;
                return draft;
            }
            case ActionTypes.INTERNATIONALIZATION_FAILED: {
                draft.isLoading = false;
                return draft;
            }
            case ActionTypes.FETCH_ALL_COUNTRIES_CURRENCIES: {
                draft = payload;
                draft.isLoading = true;
                return draft;
            }

            case ActionTypes.OPEN_COUNTRIES_CURRENCIES_SETTINGS: {
                draft.openDialog = true;
                return draft;
            }

            case ActionTypes.CLOSE_COUNTRIES_CURRENCIES_SETTINGS: {
                draft.openDialog = false;
                return draft;
            }

            case ActionTypes.SET_INTERNATIONALIZATION_SUCCESS: {
                draft.isLoading = false;
                draft.hasUpdatedI18n = true;
                return draft;
            }

            case ActionTypes.UPDATE_CURRENCY: {
                draft.currency = payload.currency;
                draft.currencyDisplayValue = payload.currencyDisplayValue;
                return draft;
            }

            case ActionTypes.UPDATE_COUNTRY: {
                draft.country = payload.country;
                draft.countryCode = payload.countryCode;
                draft.flagUrl = payload.flagUrl;
                return draft;
            }

            case ActionTypes.ALLOW_XHR_REQUESTS: {
                draft.isXHRAllowed = true;
                return draft;
            }
        }
    });
